// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-jsx": () => import("./../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-components-jsx": () => import("./../src/pages/components.jsx" /* webpackChunkName: "component---src-pages-components-jsx" */),
  "component---src-pages-index-jsx": () => import("./../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-templates-webinar-jsx": () => import("./../src/templates/Webinar.jsx" /* webpackChunkName: "component---src-templates-webinar-jsx" */),
  "component---src-templates-whitepaper-jsx": () => import("./../src/templates/Whitepaper.jsx" /* webpackChunkName: "component---src-templates-whitepaper-jsx" */)
}

